import script from "./ChatContentContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContentContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ChatContentContainer.vue?vue&type=style&index=0&id=20eaa234&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20eaa234"]])

export default __exports__